/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddOrUpdateRewardRequest} from '@cash-web/protos/squareup/franklin/app/rewards.pb'
import {AddOrUpdateRewardResponse} from '@cash-web/protos/squareup/franklin/app/rewards.pb'


export const addOrUpdateReward = (request: AddOrUpdateRewardRequest, options?: CashRequestOptions) => post<AddOrUpdateRewardRequest, AddOrUpdateRewardResponse>("/2.0/cash/add-or-update-reward", request, {...options, rejectOnError: true })